// extracted by mini-css-extract-plugin
export default {"box":"event-counter-box_box__-hPyW","progress":"event-counter-box_progress__7HePu","content":"event-counter-box_content__Sgf37"};